import { Tab, TabBody, TabHeader, Tabs } from '../../components/Tabs';
import LeaderboardState from '../../context/leaderboard/LeaderboardState';
import LeaderboardVolume from './Volume/LeaderboardVolume';
import LeaderboardPnL from './PnL/LeaderboardPnL';
import UserRanking from './UserRanking';
// import useUserRankings from '../../hooks/analytics/useUserRankings';
import useMockUserRankings from '../../hooks/analytics/useMockUserRankings';
import Spinner from '../../components/Spinner';
import { useState } from 'react';
import useLeaderboadState from '../../context/leaderboard/useLeaderboardState';
import { ActiveSort } from '../../context/leaderboard/leaderboardTypes';
import Button from '../../components/Button';

const ROW_MARGIN = 16;
const DATA_PER_ROW = 5;

export type LeaderboardProps = {
    rowMargin: number;
    dataPerRow: number;
};

const Leaderboard = () => (
    <section id='leaderboard'>
        <aside className='leaderboard-banner'>
            <p>
                Our <strong>Mainnet Competition</strong> with{' '}
                <strong>$62.5K+ prizes</strong> is <strong>LIVE!</strong>
            </p>
            <Button externalLink='https://comps.unlimited.trade/'>
                Go to Competition Leaderboard
            </Button>
        </aside>
        <div className='container'>
            <LeaderboardState>
                <LeaderboardWrapper />
            </LeaderboardState>
        </div>
    </section>
);

export default Leaderboard;

const LeaderboardWrapper = () => {
    // const { isLoading } = useUserRankings();
    const { isLoading } = useMockUserRankings();

    const { activeSort, setSort } = useLeaderboadState();

    const [tabIndex, setTabIndex] = useState(0);

    const handleSort = (sortKey: ActiveSort['sortKey']) => {
        if (activeSort.sortKey === sortKey) return;

        setSort(sortKey);
    };

    return isLoading ? (
        <div className='loading-container'>
            <Spinner />
            <span>Loading leaderboard...</span>
        </div>
    ) : (
        <Tabs tabIndex={tabIndex} setTabIndex={setTabIndex}>
            <UserRanking dataPerRow={DATA_PER_ROW} />
            <TabHeader>
                <Tab onClick={() => handleSort('realizedPnL')}>Top PnL</Tab>
                <Tab onClick={() => handleSort('totalVolume')}>Top Volume</Tab>
            </TabHeader>
            <TabBody>
                <LeaderboardPnL rowMargin={ROW_MARGIN} dataPerRow={DATA_PER_ROW} />
                <LeaderboardVolume rowMargin={ROW_MARGIN} dataPerRow={DATA_PER_ROW} />
            </TabBody>
        </Tabs>
    );
};
